export default __webpack_public_path__ + "static/media/logo-burger-king.50b4dd88.png";